import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { addClass, removeClass } from '@fretadao/f-js-dom';

application.register('waitlist-form', class extends Controller {
  static targets = ['form', 'fields', 'successCard'];

  showSuccess () {
    removeClass(this.successCardTarget, 'hidden');
    addClass(this.fieldsTarget, 'hidden');
  }
});
